import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../assets/logo-new.png';

const menuItems = [
  {
    label: 'Company',
    children: [
      { label: 'Team', path: '/about' },
      { label: 'Partners', path: '/partners' },
      { label: 'Contact', path: '/contact' },
      { label: 'News', path: '/news' }
    ]
  },
  {
    label: 'Products',
    children: [
      { label: 'NaaS Cloud', path: '/naascloud' },
      { label: 'Mobile App', path: '/mobileapp' },
      { label: 'Open Hardware', path: '/openhardware' },
      { label: 'NAC', path: '/nac' },
      { label: 'Security', path: '/security' }
    ]
  },
  {
    label: 'Solutions',
    children: [
      { label: 'MDU', path: '/mdu' },
      { label: 'Hospitality', path: '/hospitality' },
      { label: 'Education', path: '/education' },
      { label: 'Warehouses', path: '/warehouses' }
    ]
  },
  {
    label: 'Resources',
    children: [
      { label: 'White Papers', path: '/whitepapers' },
      { label: 'Knowledge Center', path: '/knowledgecenter' },
      { label: 'Blog', path: '/blogs' }
    ]
  }
];

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const navigate = useNavigate();

  const closeAll = () => {
    setMobileOpen(false);
    setOpenDropdown(null);
  };

  const handleNavClick = (path) => {
    closeAll();
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <header ref={dropdownRef} style={{
      backgroundColor: '#000503', borderBottom: '1px solid #1a2744',
      position: 'sticky', top: 0, zIndex: 100
    }}>
      <div style={{
        maxWidth: '1200px', margin: '0 auto', padding: '0 24px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: '64px'
      }}>
        {/* Logo */}
        <Link to="/" onClick={closeAll} style={{ display: 'flex', alignItems: 'center' }}>
          <img src={logo} alt="Sarvanta" style={{ height: '40px' }} />
        </Link>

        {/* Desktop Nav */}
        {!isMobile && (
          <nav style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Link to="/" onClick={closeAll} style={{
              background: 'none', border: 'none', color: '#e2e8f0',
              padding: '8px 16px', textDecoration: 'none', fontSize: '0.95rem'
            }}>Home</Link>
            {menuItems.map((menu, i) => (
              <div key={i} style={{ position: 'relative' }}>
                <button
                  onClick={() => setOpenDropdown(openDropdown === i ? null : i)}
                  style={{
                    background: 'none', border: 'none', color: '#e2e8f0',
                    padding: '8px 16px', cursor: 'pointer', fontSize: '0.95rem',
                    display: 'flex', alignItems: 'center', gap: '4px'
                  }}
                >
                  {menu.label}
                  <span style={{ fontSize: '0.7rem' }}>&#9660;</span>
                </button>
                {openDropdown === i && (
                  <div style={{
                    position: 'absolute', top: '100%', left: 0,
                    backgroundColor: '#0a1628', border: '1px solid #1a2744',
                    borderRadius: '8px', minWidth: '180px', padding: '8px 0',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.4)'
                  }}>
                    {menu.children.map((child, j) => (
                      <Link key={j} to={child.path} onClick={() => { closeAll(); window.scrollTo(0, 0); }} style={{
                        display: 'block', padding: '10px 20px', color: '#a0aec0',
                        textDecoration: 'none', fontSize: '0.9rem'
                      }}>{child.label}</Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <Link to="/contact" onClick={closeAll} style={{
                padding: '8px 18px', border: '1px solid #0891b2', color: '#22d3ee',
                borderRadius: '6px', textDecoration: 'none', fontSize: '0.85rem',
                fontWeight: '600', marginLeft: '8px'
              }}>Request Demo</Link>
            <a href="https://naas.sarvantanet.com" target="_blank" rel="noopener noreferrer"
              style={{
                padding: '8px 20px', background: 'linear-gradient(135deg, #2563eb, #0891b2)', color: '#fff',
                borderRadius: '6px', textDecoration: 'none', fontSize: '0.9rem',
                fontWeight: '600', marginLeft: '4px'
              }}>Customer Login</a>
          </nav>
        )}

        {/* Mobile Hamburger */}
        {isMobile && (
          <button onClick={() => setMobileOpen(!mobileOpen)} style={{
            background: 'none', border: 'none', color: '#fff', fontSize: '1.5rem',
            cursor: 'pointer', padding: '8px'
          }}>
            {mobileOpen ? '\u2715' : '\u2630'}
          </button>
        )}
      </div>

      {/* Mobile Menu */}
      {isMobile && mobileOpen && (
        <nav style={{
          backgroundColor: '#0a1628', borderTop: '1px solid #1a2744',
          padding: '16px 24px', maxHeight: '80vh', overflowY: 'auto'
        }}>
          <button onClick={() => handleNavClick('/')} style={{
            display: 'block', padding: '10px 0', color: '#e2e8f0', background: 'none',
            border: 'none', fontSize: '1rem', marginBottom: '8px', cursor: 'pointer',
            textAlign: 'left', width: '100%'
          }}>Home</button>
          {menuItems.map((menu, i) => (
            <div key={i} style={{ marginBottom: '8px' }}>
              <button
                onClick={() => setOpenDropdown(openDropdown === i ? null : i)}
                style={{
                  background: 'none', border: 'none', color: '#e2e8f0',
                  padding: '10px 0', cursor: 'pointer', fontSize: '1rem',
                  width: '100%', textAlign: 'left', display: 'flex',
                  justifyContent: 'space-between', alignItems: 'center'
                }}
              >
                {menu.label}
                <span style={{ fontSize: '0.7rem' }}>{openDropdown === i ? '\u25B2' : '\u25BC'}</span>
              </button>
              {openDropdown === i && (
                <div style={{ paddingLeft: '16px' }}>
                  {menu.children.map((child, j) => (
                    <button key={j} onClick={() => handleNavClick(child.path)} style={{
                      display: 'block', padding: '8px 0', color: '#a0aec0',
                      background: 'none', border: 'none', cursor: 'pointer',
                      fontSize: '0.9rem', textAlign: 'left', width: '100%'
                    }}>{child.label}</button>
                  ))}
                </div>
              )}
            </div>
          ))}
          <a href="https://naas.sarvantanet.com" target="_blank" rel="noopener noreferrer"
            style={{
              display: 'block', padding: '12px 20px', backgroundColor: '#2563eb',
              color: '#fff', borderRadius: '6px', textDecoration: 'none',
              fontSize: '0.9rem', fontWeight: '600', textAlign: 'center', marginTop: '12px'
            }}>Customer Login</a>
        </nav>
      )}
    </header>
  );
};

export default Header;
